<script setup lang="ts">
defineOptions({ inheritAttrs: false });
</script>

<template>
    <VListItemSubtitle
        v-bind="$attrs"
        class="b-list-item-subtitle"
    >
        <slot />
    </VListItemSubtitle>
</template>
